import React from 'react';
import '../styles/AudioEqualizer.css';

const AudioEqualizer = ({ isPlaying }) => {
  return (
    <div className={`equalizer ${isPlaying ? 'playing' : ''}`}>
      <div className="equalizer-bar"></div>
      <div className="equalizer-bar"></div>
      <div className="equalizer-bar"></div>
      <div className="equalizer-bar"></div>
      <div className="equalizer-bar"></div>
    </div>
  );
};

export default AudioEqualizer; 